import { getProductUrl, type ProductHit } from '@libs/algolia';
import type { ImageType } from '@libs/common-types';

import type { ProductVariant } from '@/entities/product';

export type MappedFBTProduct = {
    isMainProduct: boolean;
    id: string;
    name: string;
    priceStyleVariant: 'sale' | 'primary';
    displayPrice: number;
    displayImage: string;
    url: string;
    inStock: boolean;
};

type MapFBTProductsOptions = {
    product: ProductVariant;
    productStock: number;
    recommendedProducts: ProductHit[];
};

export const mapFBTProducts = ({
    product,
    productStock,
    recommendedProducts,
}: MapFBTProductsOptions): MappedFBTProduct[] => {
    const minProductPurchaseQuantity = product.deliveryMethods.BOPIS.purchaseQuantities?.min ?? 1;
    const mappedProduct = {
        isMainProduct: true,
        id: product.sku,
        name: product.name,
        priceStyleVariant: product.price.sale ? ('sale' as const) : ('primary' as const),
        displayPrice: product.price.sale ?? product.price.original ?? 0.0,
        // ts-check is failing for some reason
        displayImage: (product.media as ImageType[]).find(media => media.type === 'image')?.url ?? '',
        url: '',
        inStock: productStock >= minProductPurchaseQuantity,
    };

    const mappedRecommendedProducts = recommendedProducts.map(recommendedProduct => ({
        isMainProduct: false,
        id: recommendedProduct.objectID,
        name: recommendedProduct.name ?? '',
        priceStyleVariant: recommendedProduct.price?.formatted.strikethrough ? ('sale' as const) : ('primary' as const),
        displayPrice: recommendedProduct.price?.number ?? 0.0,
        displayImage: recommendedProduct.images?.small ?? '',
        url: getProductUrl(recommendedProduct),
        inStock: recommendedProduct.in_stock ?? false,
    }));

    return [mappedProduct, ...mappedRecommendedProducts];
};
